import React, { useState, useMemo } from 'react';
import { Download, ArrowUpDown, ChevronDown, ChevronUp, Loader } from 'lucide-react';
import { FaRegFilePdf, FaRegFileWord } from 'react-icons/fa'; 
import { useLanguage } from '../context/LanguageContext';

const PdfPrastavNamune = () => {
  const { language } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  const initialData = [
    { id: 1, name: 'मातोश्री पाणंद रस्ता प्रस्ताव- ता. हदगाव जि. नांदेड', type: 'pdf' },
    { id: 2, name: 'मोदी आवास योजना फाईल- बार्शी सोलापूर', type: 'pdf' },
    { id: 3, name: 'mgnrega गाय गोठा प्रस्ताव', type: 'pdf' },
    { id: 4, name: 'सार्वजनिक शौचालय प्रस्ताव- सांगली जिल्हा', type: 'pdf' },
    { id: 5, name: 'व्यायामशाळा साहित्य प्रस्ताव- धाराशिव जिल्हा', type: 'pdf' },
    { id: 6, name: 'बुलडाणा- मा. बाळासाहेब ठाकरे स्मृती मातोश्री ग्रामपंचायत इमारत बांधकाम प्रस्ताव pdf', type: 'pdf' },
    { id: 7, name: 'पंडित दिनदयाळ उपाध्याय घरकुल जागा खरेदी योजना प्रस्ताव- सातारा जिल्हा', type: 'pdf' },
    { id: 8, name: 'व्यायाम शाळा विकास अनुदान प्रस्ताव- लातूर जिल्हा', type: 'pdf' },
    { id: 9, name: 'ठक्कर बाप्पा प्रस्ताव - जि. जळगाव', type: 'pdf' },
    { id: 10, name: 'ठक्कर बाप्पा प्रस्ताव - धारणी जि. अमरावती', type: 'pdf' },
    { id: 11, name: 'सामाजिक विकास योजना प्रस्ताव नमुना- सातारा जिल्हा', type: 'pdf' },
    { id: 12, name: 'शाळा खोली निर्लेखन प्रस्ताव pdf', type: 'pdf' },
    { id: 13, name: 'वसंतराव नाईक तांडा वस्ती सुधार योजना प्रस्ताव नमुना - पुणे जिल्हा', type: 'pdf' },
    { id: 14, name: 'यशवंतराव चव्हाण मुक्त वसाहत घरकुल प्रस्ताव- जालना जिल्हा', type: 'pdf' },
    { id: 15, name: 'जनसुविधा प्रस्ताव नमुना- नाशिक', type: 'pdf' },
    { id: 16, name: 'शासकीय जमीन मागणी प्रपत्र अबकड', type: 'pdf' },
    { id: 17, name: 'आदर्श ग्रामसेवक पुरस्कार प्रस्ताव word', type: 'word' },
    { id: 18, name: 'संविधान सभागृह बांधकाम करणे- प्रस्ताव नमुना', type: 'pdf' },
    { id: 19, name: 'घनकचरा व सांडपाणी व्यवस्थापन प्रकल्प प्रस्ताव (सुधारित)', type: 'pdf' },
    { id: 20, name: 'अनुसूचित जाती व नवबौद्ध घटकांच्या वस्तीचा विकास योजना (दलितवस्ती सुधार)प्रस्ताव', type: 'pdf' },
    { id: 21, name: 'जनसुविधा प्रस्ताव (अहमदनगर)', type: 'pdf' },
    { id: 22, name: 'मातोश्री ग्रामसमृद्धी शेत/पाणंद रस्ते प्रस्ताव word', type: 'word' },
    { id: 23, name: 'मातोश्री ग्रामसमृद्धी शेत/पाणंद रस्ते प्रस्ताव', type: 'pdf' },
    { id: 24, name: 'ग्रामपंचायत विभाजन प्रस्ताव नमुना (भरलेला)-1', type: 'pdf' },
    { id: 25, name: 'ग्रामपंचायत विभाजन प्रस्ताव नमुना (भरलेला)-2', type: 'pdf' },
    { id: 26, name: 'ग्रा.पं. इमारत बांधकाम प्रस्ताव', type: 'pdf' },
    { id: 27, name: 'तिर्थक्षेत्र विकास प्रस्ताव- (क वर्ग) pdf', type: 'pdf' },
    { id: 28, name: 'तिर्थक्षेत्र विकास प्रस्ताव- (ब वर्ग) pdf', type: 'pdf' },
  ];

  const [generatingId, setGeneratingId] = useState(null);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = useMemo(() => {
    let sortableItems = [...initialData];

    if (searchTerm) {
      sortableItems = sortableItems.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.id.toString().includes(searchTerm)
      );
    }

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  }, [searchTerm, sortConfig]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="w-4 h-4 text-gray-300 mx-1 inline" />;
    }
    return sortConfig.direction === 'ascending' 
      ? <ChevronUp className="w-4 h-4 text-gray-500 mx-1 inline" /> 
      : <ChevronDown className="w-4 h-4 text-gray-500 mx-1 inline" />;
  };

  const generatePDF = async (item) => {
    setGeneratingId(item.id);
    // Simulate loading for now since actual files aren't linked yet
    setTimeout(() => {
      setGeneratingId(null);
      alert(language === 'marathi' ? `${item.name} डाउनलोड लवकरच उपलब्ध होईल!` : `${item.name} download will be available soon!`);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col font-sans">
      <main className="flex-grow py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Card Container */}
          <div className="bg-white shadow-xl rounded-lg border border-gray-200 overflow-hidden">
            
            {/* Header Title Bar */}
            <div className="bg-[#fff1c9] border-b border-[#e5d4a1] py-2 px-4 flex justify-between items-center gap-2">
              <h2 className="text-[#000080] text-[15px] sm:text-xl font-bold flex items-center ">
            {/* Custom dark blue multi-pointed star as in the image */}
                <svg className="w-5 h-5 mr-3 text-[#000080] fill-current" viewBox="0 0 24 24">
                   <path d="M12 2l2.4 2.4L18 3.5l1.5 3.3 3.5.9-1.2 3.2 2.2 2.6-2.2 2.6 1.2 3.2-3.5.9-1.5 3.3-3.6-1.1L12 22l-2.4-2.4L6 20.5l-1.5-3.3-3.5-.9 1.2-3.2-2.2-2.6 2.2-2.6-1.2-3.2 3.5-.9 1.5-3.3 3.6 1.1z"/>
                </svg>
                {language === 'marathi' ? 'प्रस्ताव नमुने' : 'Proposal Forms'}
          </h2>
          <button onClick={() => window.history.back()} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
                  {language === 'marathi' ? 'मागे जा' : 'Back'}
                </button>
            </div>

            {/* Search Bar */}
            <div className="flex justify-end bg-white py-3 px-4 border-b border-gray-200">
              <div className="flex items-center">
                <label className="text-gray-600 mr-2 text-sm font-medium">Search:</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-[#337ab7] focus:ring-1 focus:ring-[#337ab7] w-48"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset page on search
                  }}
                />
              </div>
            </div>

            {/* Table Container for responsiveness */}
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse min-w-[700px]">
                <thead>
                  <tr className="bg-[#fdfdfd] border-b-2 border-gray-200 shadow-sm">
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap"
                      onClick={() => handleSort('id')}
                      style={{ width: '80px' }}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नं' : 'No'}</span>
                         <SortIcon columnKey="id" />
                      </div>
                    </th>
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors"
                      onClick={() => handleSort('name')}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नाव' : 'Name'}</span>
                         <SortIcon columnKey="name" />
                      </div>
                    </th>
                    <th className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm text-center w-32 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'प्रकार' : 'Type'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                    <th className="py-3 px-4 font-bold text-[#00008b] text-sm text-center w-48 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'डाऊनलोड करा' : 'Download'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr 
                         key={item.id} 
                         className={`border-b border-gray-200 hover:bg-[#f8fafc] transition-colors ${index % 2 === 0 ? 'bg-[#fbfbfb]' : 'bg-white'}`}
                      >
                        <td className="py-2.5 px-4 text-sm text-[#000080] border-r border-gray-100 text-left font-medium">
                          {item.id}
                        </td>
                        <td className="py-2.5 px-4 text-sm text-[#4a729e] border-r border-gray-100">
                          {item.name}
                        </td>
                        <td className="py-2.5 px-4 text-center border-r border-gray-100">
                          {item.type === 'word' ? (
                             <FaRegFileWord className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          ) : (
                             <FaRegFilePdf className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          )}
                        </td>
                        <td className="py-2.5 px-4 text-center">
                          <button 
                            onClick={() => generatePDF(item)}
                            disabled={generatingId === item.id}
                            className={`text-white text-xs px-3 py-1.5 rounded-sm flex items-center justify-center mx-auto space-x-1 shadow-sm transition-all flex-nowrap w-36 ${
                              generatingId === item.id 
                                ? 'bg-gray-500 cursor-not-allowed' 
                                : 'bg-[#00a65a] hover:bg-[#008d4c]'
                            }`}
                          >
                            {generatingId === item.id ? (
                               <Loader className="w-3.5 h-3.5 animate-spin" />
                            ) : (
                               <Download className="w-3.5 h-3.5" />
                            )}
                            <span className="font-semibold whitespace-nowrap">
                              {generatingId === item.id ? 'Loading...' : 'View/Download'}
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="py-6 text-center text-gray-500">
                        {language === 'marathi' ? 'कोणताही प्रस्ताव सापडला नाही.' : 'No proposals found.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="flex justify-end items-center bg-gray-50 px-4 py-3 border-t border-gray-200">
                <div className="flex space-x-1 shadow-sm">
                  <button 
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 px-3 py-1 text-sm rounded-l-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Previous
                  </button>
                  
                  {/* Dynamically generate page numbers */}
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => setCurrentPage(i + 1)}
                      className={`${
                        currentPage === i + 1 
                        ? 'bg-[#337ab7] text-white border-[#337ab7]' 
                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                      } border-y border-r px-3 py-1 text-sm`}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button 
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages || totalPages === 0}
                    className="bg-white border-y border-r border-gray-300 text-[#337ab7] hover:bg-gray-50 px-3 py-1 text-sm rounded-r-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </main>
    </div>
  );
};

export default PdfPrastavNamune;
